import { newLogger } from "@/utils/util";
import StoreCore from "../../../StoreCore";
import network from "@/utils/network";

let logger = newLogger("Enterprise-RiskManagement");
const urls = {
  unknownTimesheets: (urlSearchParams) =>
    `/enterprise/risk-management/unknown-timesheets?${urlSearchParams.toString()}`,
  unknownExport: (urlSearchParams) =>
    `/enterprise/risk-management/unknown-timesheets/export?${urlSearchParams.toString()}`,
  missingTimesheets: (urlSearchParams) =>
    `/enterprise/risk-management/missing-timesheets?${urlSearchParams.toString()}`,
  unknownIssues: (urlSearchParams) =>
    `/enterprise/risk-management/unknown-issues?${urlSearchParams.toString()}`,
  sharedIssues: (urlSearchParams) =>
    `/enterprise/risk-management/shared-issues?${urlSearchParams.toString()}`,
  loggingWillingness: (urlSearchParams) =>
    `/enterprise/risk-management/logging-willingness?${urlSearchParams.toString()}`,
  ignoredPrefix: (id) =>
    `/enterprise/risk-management/ignored-prefixes/${encodeURIComponent(id)}`,
  ignoredPrefixes: "/enterprise/risk-management/ignored-prefixes",
};

const initState = () => {
  return {
    unknownTimesheets: {},
    missingTimesheets: {},
    sharedIssues: {},
    unknownIssues: {},
    loggingWillingness: {},
    ignoredPrefixes: [],
  };
};

const storeCore = new StoreCore();
const actions = {
  fetchMissingTimesheets: async function ({ commit, dispatch }) {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("onlyMyTeam", "false");
    try {
      let data = await this.remoteRequest(
        "get",
        urls.missingTimesheets(urlSearchParams),
        null,
        true,
        dispatch,
        "Hiányzó logolások letöltése..."
      );
      commit("saveMissingTimesheets", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  fetchUnknownIssues: async function ({ commit, dispatch }, prefix) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("prefix", prefix);
      let data = await this.remoteRequest(
        "get",
        urls.unknownIssues(urlSearchParams),
        null,
        true,
        dispatch,
        "Ismeretlen jegyek letöltése..."
      );
      commit("saveUnknownIssues", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  fetchUnknownTimesheets: async function ({ commit, dispatch }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set("onlyMyTeam", "false");
      let data = await this.remoteRequest(
        "get",
        urls.unknownTimesheets(urlSearchParams),
        null,
        true,
        dispatch,
        "Ismeretlen logolások letöltése..."
      );
      commit("saveUnknownTimesheets", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  fetchSharedIssues: async function ({ commit, dispatch }, id) {
    try {
      const urlSearchParams = new URLSearchParams();
      if (id) urlSearchParams.append("id", id);
      let data = await this.remoteRequest(
        "get",
        urls.sharedIssues(urlSearchParams),
        null,
        true,
        dispatch,
        "Többszörösen célzott jegyek letöltése..."
      );
      commit("saveSharedIssues", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  fetchIgnoredPrefixes: async function ({ commit, dispatch }, force) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.ignoredPrefixes,
        null,
        true,
        dispatch,
        "Ignorált prefixek letöltése...",
        null,
        force
      );
      commit("saveIgnoredPrefixes", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  fetchLoggingWillingness: async function ({ commit, dispatch }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("onlyMyTeam", "false");
      let data = await this.remoteRequest(
        "get",
        urls.loggingWillingness(urlSearchParams),
        null,
        true,
        dispatch,
        "Logolási hajlandóságok letöltése..."
      );
      commit("saveLoggingWillingness", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  createIgnoredPrefix: async function ({ commit, dispatch }, ignoredPrefix) {
    try {
      await this.remoteRequest(
        "post",
        urls.ignoredPrefixes,
        ignoredPrefix,
        false,
        dispatch,
        "Ignorált prefix létrehozása..."
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  editIgnoredPrefix: async function ({ commit, dispatch }, ignoredPrefix) {
    try {
      await this.remoteRequest(
        "put",
        urls.ignoredPrefixes,
        ignoredPrefix,
        false,
        dispatch,
        "Ignorált prefix szerkesztése...",
        undefined,
        undefined,
        false,
        true,
        {
          progress: "Prefix mentése folyamatban...",
          fail: "Prefix mentése sikertelen!",
          success: "Prefix mentése sikeres!",
        }
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  deleteIgnoredPrefix: async function ({ commit, dispatch }, prefix) {
    try {
      await this.remoteRequest(
        "delete",
        urls.ignoredPrefix(prefix),
        null,
        true,
        dispatch,
        "Ignorált prefix törlése..."
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  exportUnknown: async function ({ dispatch }, { since }) {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("since", since);
    dispatch(
      "loading/startLoading",
      {
        id: 1337,
        type: "GET",
        url: urls.unknownExport(urlSearchParams),
        flair: "Ismeretlen logolások exportálása...",
      },
      { root: true }
    );

    try {
      const axios = await network.excelConnection();
      const { data } = await axios.get(urls.unknownExport(urlSearchParams));

      dispatch(
        "loading/finishLoading",
        { id: 1337, result: true },
        { root: true }
      );

      return data;
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  },
  clearCache: async function ({}) {
    this.clearCoreCache();
  }.bind(storeCore),
};

const mutations = {
  saveMissingTimesheets: (state, stuff) => {
    state.missingTimesheets = stuff;
  },
  saveUnknownIssues: (state, issues) => {
    state.unknownIssues = issues;
  },
  saveUnknownTimesheets: (state, stuff) => {
    state.unknownTimesheets = stuff;
  },
  saveSharedIssues: (state, issues) => {
    state.sharedIssues = issues;
  },
  saveLoggingWillingness: (state, stuff) => {
    state.loggingWillingness = stuff;
  },
  saveIgnoredPrefixes: (state, ignoredPrefixes) => {
    state.ignoredPrefixes = ignoredPrefixes;
  },
};

const getters = {
  getMissingTimesheets: (state) => {
    return state.missingTimesheets;
  },
  getUnknownIssues: (state) => {
    return state.unknownIssues;
  },
  getUnknownIssuesFiltered: (state) => (filter) => {
    for (let p in state.unknownIssues.projects) {
      let record = state.unknownIssues.projects[p];
      if (record.prefix === filter) return record.issues;
    }
    return [];
  },
  getUnknownTimesheets: (state) => {
    return state.unknownTimesheets;
  },
  getSharedIssues: (state) => {
    return state.sharedIssues;
  },
  getSharedIssuesFiltered: (state) => (filter) => {
    for (let p in state.sharedIssues.projects) {
      let record = state.sharedIssues.projects[p];
      if (record.prefix === filter) return record.issues;
    }
    return [];
  },
  getLoggingWillingness: (state) => {
    return state.loggingWillingness;
  },
  getIgnoredPrefixes: (state) => {
    return state.ignoredPrefixes;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
